<template>
  <div class="fillSpace" v-hammer:tap="startSelectionTouch" @mouseover="startSelection()" @mouseleave="stopSelection()">
    <!-- main pane content -->
    <div class="element" style="height: 100%" v-show="!selecting || hasSelected">
      <!-- title, image, button -->
      <div v-bind:class="beforeSelect ? 'beforeSelect' : 'afterSelect'">
        <img :width="beforeSelect ? 64 : 48" :src="imagePath" />

        <p v-html="title"></p>

        <!--TODO: A rendre dynamique via BO-->
        <div v-show="!hasSelected" class="container-subtitle">
          <span class="subtitle">{{ description }}</span>
        </div>
      </div>

      <button v-bind:class="{ productSelection: !isEmbed, productSelectionEmbed: isEmbed }" @click="returnToSelect()">
        <table class="table-container">
          <tr>
            <td>
              <span class="label">{{ this.selected ? getNameById(this.selected) : this.subtitle }}</span>
            </td>
            <td>
              <img v-if="hasSelected && !isEmbed" src="../../assets/ic-arrow-drop-down.svg" class="arrow" />
            </td>
          </tr>
        </table>
      </button>

      <!--TODO: A rendre dynamique via BO-->
      <div class="container-description" v-if="hasSelected">
        <span
          class="description-product"
          v-html="getWebcontrol('ConfigurerVosVerres-Texte-Description' + selected)"
        ></span>
      </div>

      <!-- list of demos once product select -->
      <div class="demos">
        <div class="nDemos" v-show="hasSelected">{{ demos.length }} démo{{ demos.length > 1 ? 's' : '' }}</div>
        <a class="demo" href="javascript:void(0)" v-for="demo in demos" v-bind:key="demo.id" @click="go(demo.id)">
          <img class="bordered" width="20" height="20" src="../../assets/ic-play.svg" v-if="isDemoVideo(demo)" />
          <img class="bordered" width="20" height="20" src="../../assets/ic-interactive.png" v-else />
          <div class="demo-title">{{ demo.name }}</div>
        </a>
      </div>
    </div>

    <!-- only appears when selecting -->
    <div class="products" v-bind:class="{ open: selecting && !hasSelected }" v-show="selecting && !hasSelected">
      <button
        class="productButton"
        @click="endSelection({ target: { value: product.id } })"
        v-for="product in products"
        v-bind:key="product.id"
        :value="product.id"
      >
        {{ product.name }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: ['title', 'subtitle', 'category', 'image', 'defaultModelID', 'description', 'hasMoved'],

  computed: {
    isEmbed() {
      return this.$route.query.embed === 'true';
    },
    imagePath() {
      return require(`../../assets/${this.image}`);
    },
    getSelected() {
      return this.selected;
    },
  },
  mounted() {
    this.setProducts();
  },
  data() {
    return {
      enableHover: true,
      products: null,
      beforeSelect: true,
      selecting: false, // during select
      hasSelected: false,
      selected: null, // after select contains the product
      demos: [],
    };
  },
  methods: {
    getWebcontrol(key) {
      return this.$store.getters.getValueById(key);
    },
    setProducts: async function() {
      this.products = this.$store.getters.productsByCategory(this.category);
      if (this.defaultModelID) {
        //Quizz result can be array if several product for a category or a simple string if only one product
        let idSelected = Array.isArray(this.defaultModelID) ? this.defaultModelID[0] : this.defaultModelID;
        this.startSelection();
        if (this.products.filter(product => product.id === idSelected).length > 0) {
          this.$parent.$emit('setHeight', '160'); // this will make the Pane bigger
          this.endSelection({ target: { value: idSelected } });
        }
      }
    },
    getNameById(id) {
      let ret = this.$store.getters.productsByCategory(this.category).filter(product => id === product.id);
      return ret.length > 0 ? ret[0].name : null;
    },
    // on click on selection button
    startSelection() {
      if (!this.hasMoved) {
        this.enableHover = false;
      }
      if (!this.enableHover) {
        return;
      }
      this.selecting = true;
      this.$parent.$emit('setHeight', '160'); // this will make the Pane bigger
    },
    startSelectionTouch() {
      this.selecting = true;
      this.$parent.$emit('setHeight', '160'); // this will make the Pane bigger
    },
    stopSelection() {
      if (!this.enableHover) {
        this.enableHover = true;
      }
      if (!this.hasSelected) {
        this.beforeSelect = true;
        this.selecting = false; // during select
        this.selected = null; // after select contains the product
        this.demos = [];
        this.$parent.$emit('setHeight', '100'); // this will make the Pane bigger
        this.$emit('hasSelected', this.hasSelected);
      }
    },

    returnToSelect() {
      if (!this.isEmbed) {
        this.beforeSelect = true;
        this.selecting = true;
        this.hasSelected = false;
        this.selected = null; // after select contains the product
        this.demos = [];
        this.$store.commit('selectProduct', {
          category: this.category,
          productId: null,
        });
      }
    },

    // once product selected
    endSelection(event) {
      this.beforeSelect = false; // we selected once, so this flag is permanent false
      this.selected = event.target.value;
      this.selectProduct();
    },

    selectProduct() {
      this.$store.commit('selectProduct', {
        category: this.category,
        productId: this.selected,
      });
      let idProduct = this.$route.params.id
        ? this.$store.getters.getProductByDemoId(this.$route.params.id).id
        : this.selected;
      this.demos = this.$store.getters.demosByProduct(idProduct).filter(demo => demo.isActive);
      this.hasSelected = true;
      this.$emit('hasSelected', this.hasSelected);
    },
    // go to demo
    go(demoId) {
      this.$router.push(this.keepQueryParams(this.$store.getters.getDemoLink(demoId))).catch(err => {
        this.$log.error(err);
      });
    },
    keepQueryParams(url) {
      let newUrl = url;
      if (this.$route.query.embed === 'true') {
        newUrl += (newUrl.indexOf('?') > 0 ? '&' : '?') + 'embed=true';
      }
      if (this.$route.query.optimize || this.$route.query.correct || this.$route.query.protect) {
        newUrl +=
          (newUrl.indexOf('?') > 0 ? '&' : '?') +
          'optimize=' +
          this.$route.query.optimize +
          '&correct=' +
          this.$route.query.correct +
          '&protect=' +
          this.$route.query.protect;
      }
      return newUrl;
    },
    //return true if the demo first situation is of type play
    isDemoVideo(demo) {
      return demo.situations[0].media.type === 'video';
    },
  },
};
</script>

<style scoped>
.table-container {
  margin-left: auto;
  margin-right: auto;
}

.arrow {
  padding-left: 14.7px;
  padding-top: 6px;
}

.fillSpace {
  display: flex;
  position: relative;
  height: 100%;
  width: 90%;
  align-items: center;
  justify-content: center;
  overflow-x: hidden;
  overflow-y: auto;
}

.beforeSelect {
  width: 100%;
  margin-top: 4vh;
}

.afterSelect img {
  color: grey;
  opacity: 0.5;
}

.afterSelect {
  color: lightgray;
  display: inline-block;
  width: 60%;
  font-size: 1em;
}

.afterSelect p {
  margin: 0;
  font-size: 20px;
  color: black;
  opacity: 0.5;
}

.demos {
  width: 100%;
}

.demos .demo:last-child:after {
  content: '';
  position: absolute;
  left: 8%;
  right: 8%;
  height: 1px;
  bottom: 0;
  background-color: black;
  opacity: 0.1;
}

.demo {
  display: flex;
  align-items: center;
  position: relative;
  margin-top: 1vh;
  text-align: left;
  padding: 1px 1.6vw;
  font-size: 1em;
  color: black;
  text-decoration: none;
  overflow: hidden;
  min-height: 6vh;
}

.demo:before {
  content: '';
  position: absolute;
  left: 8%;
  right: 8%;
  height: 1px;
  top: 0;
  background-color: black;
  opacity: 0.1;
}

.demo:hover {
  background-color: rgba(0, 136, 236, 0.05);
}

.demo img {
  margin-right: 10px;
  min-width: 20px;
  min-height: 20px;
}

.demo + .demo {
  margin-top: 0px;
}

.description-product {
  font-family: AkhandSoft;
  font-size: 1.25em;
  font-weight: 300;
  text-align: center;
  color: #5e6a71;
}

.nDemos {
  margin: 0 20px;
  font-size: 1.1em;
  color: grey;
}

.subtitle {
  color: #0088ce;
  font-family: AkhandSoft;
  font-size: 1.2em;
  font-weight: 300;
  line-height: 1.6;
  text-align: center;
}

.container-subtitle {
  margin-left: 1.8vw;
  margin-right: 1.8vw;
}

button {
  border: none;
  background-color: transparent;
}

.productSelection .label {
  font-family: AkhandSoft;
  font-size: 1.2em;
  text-transform: uppercase;
}

.element {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  animation: anim-opacity 500ms forwards;
  animation-timing-function: ease-out;
}

.beforeSelect p {
  font-size: 30px;
  margin: auto;
  padding-top: 2vh;
  padding-bottom: 2vh;
  white-space: nowrap;
}

.beforeSelect + .productSelection {
  position: absolute;
  display: block;
  border-top: 1px solid lightgray;
  bottom: 0;
  left: 0;
  right: 0;
  height: 10vh;
  width: 100%;
  font-size: 1.1em;
  margin: auto;
}

.afterSelect {
  margin-left: auto;
  margin-right: auto;
  margin-top: 3vh;
}

.afterSelect + .productSelection {
  position: relative;
  padding: 0;
  margin-top: 2vh;
  padding-left: 10px;
  padding-right: 42px;

  margin-right: auto;
  margin-left: auto;

  max-width: 100%;
  cursor: pointer;
  overflow: visible;
}

.afterSelect + .productSelectionEmbed {
  position: relative;
  padding: 0;
  margin-top: 2vh;
  padding-left: 10px;
  padding-right: 10px;

  margin-right: auto;
  margin-left: auto;

  max-width: 100%;
  cursor: pointer;
  overflow: visible;
}

.afterSelect + .productSelection:after {
  content: '';
  position: absolute;
  top: 50%;
  right: 0px;
  margin-top: -20px;
  width: 26px;
  height: 26px;
  padding: 17px;
  border: solid rgba(0, 136, 236, 1) 1px;
  border-radius: 24px;
  background-position: center;
  background-repeat: no-repeat;
}

.no-touchevents .afterSelect + .productSelection:hover::after {
  border: solid rgba(0, 0, 0, 1) 1px;
}

.afterSelect + .productSelection .label {
  border-bottom: 2px solid #0088ec;
  display: inline-block;
  padding-bottom: 1vh;
  font-size: 1.7em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.afterSelect + .productSelectionEmbed .label {
  border-bottom: 2px solid #0088ec;
  display: inline-block;
  padding-bottom: 1vh;
  font-size: 1.7em;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 100%;
}

.productSelection img {
  position: absolute;
  top: 50%;
  margin-top: -20px;
}

.products {
  width: 100%;
  height: 100%;
  padding: 33% 0;
}

.products.open {
  animation-timing-function: ease-out;
}

.productButton {
  width: auto;
  font-family: AkhandSoft;
  font-weight: 300;
  font-size: 1.2em;
  display: block;
  margin: auto;
  text-align: center;
  color: #5e6a71;
  height: 6vh;
  cursor: pointer;
  background-color: transparent;
  position: relative;
}

.no-touchevents .productButton:hover {
  color: black;
}

.no-touchevents .productButton:hover:after {
  content: '';
  position: absolute;
  display: block;
  padding-top: 4px;
  width: 55%;
  text-align: center;
  border-bottom: 2px solid #0088ec;
}

.container-description {
  padding: 2vh 2vw;
  display: flex;
}

/*
résolution moins de 1024
*/
@media (max-width: 1024px), (max-height: 768px) {
  .beforeSelect p {
    font-size: 20px;

    margin: auto;
    padding-top: 0;
    vertical-align: middle;
    padding-bottom: 8%;
    white-space: nowrap;
  }

  .productButton {
    width: auto;
    font-family: AkhandSoft;
    font-weight: 300;
    font-size: 18px;
    display: block;
    margin: auto;
    text-align: center;
    color: #5e6a71;
    height: 46px;
    cursor: pointer;
    background-color: transparent;
  }

  .no-touchevents .productButton:hover:after {
    content: '';
    position: absolute;
    display: block;
    padding-top: 4px;
    width: 40px;
    text-align: center;
    border-bottom: 2px solid #0088ec;
  }

  .subtitle {
    color: #0088ce;
    font-family: AkhandSoft;
    font-size: 15px;
    font-weight: 300;
    line-height: 1.6;
    text-align: center;
  }

  .productSelection .label {
    font-family: AkhandSoft;
    font-size: 15px;
    text-transform: uppercase;
  }

  .beforeSelect + .productSelection {
    position: absolute;
    display: block;
    border-top: 1px solid lightgray;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;
    width: 100%;
    font-size: 18px;
    margin: auto;
  }
  .afterSelect + .productSelection .label {
    border-bottom: 2px solid #0088ec;
    display: inline-block;
    padding-bottom: 5px;
    font-size: 16px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    width: 100%;
  }
  .afterSelect p {
    font-size: 12px;
  }
  .description-product {
    font-family: AkhandSoft;
    font-size: 14px;
    font-weight: 300;
    text-align: center;
    color: #5e6a71;
  }

  .demo {
    display: flex;
    align-items: center;
    position: relative;
    margin-top: 10px;
    text-align: left;
    padding: 8%;
    padding-bottom: 1px;
    padding-top: 1px;
    font-size: 13px;
    color: black;
    text-decoration: none;
    overflow: hidden;
  }
  .demo-title {
    line-height: 1em;
  }
  .nDemos {
    margin: 0 20px;
    font-size: 11px;
    color: grey;
  }
  .afterSelect + .productSelection {
    position: relative;
    margin-top: 10px;

    margin-right: auto;
    margin-left: auto;

    max-width: 100%;
    cursor: pointer;
    overflow: visible;
  }
  .afterSelect img {
    width: 30px;
  }
  .beforeSelect img {
    width: 40px;
  }
  .container-description {
    padding: 10px 32px;
  }
  .demo img {
    margin-right: 10px;
    width: 10px;
  }
}
</style>
